import { render, staticRenderFns } from "./DossierDocumentCard.vue?vue&type=template&id=24e65be2&scoped=true&"
import script from "./DossierDocumentCard.vue?vue&type=script&lang=js&"
export * from "./DossierDocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./DossierDocumentCard.vue?vue&type=style&index=0&id=24e65be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e65be2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
